import React, { useEffect } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import styles from "./index.module.css";
import LeadCaptureForm from "../../components/LeadCaptureForm/";
import { Helmet } from "react-helmet";
import parse from 'html-react-parser';

const ContactUs = () => {
  const imgCDNURL = process.env.REACT_APP_CHOOSELOWRATES_RESOURCES;
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Loan officers data
  const loanOfficersData = [
    {
      name: "Kael Leather",
      nmls: "497027",
      title: "Loan Officer",
      imgUrl: "https://kaelleather.sunwestmortgage.com/images/P002.jpg",
      angelaiUrl: "askangel.ai/kleather",
      branchNmls: "2549108"
    },
    {
      name: "Joe Simmons",
      nmls: "513072",
      title: "Mortgage Loan Officer",
      imgUrl: "https://kaelleather.sunwestmortgage.com/images/A161.jpg",
      angelaiUrl: "askangel.ai/josephsimmons",
      phone: "(614) 963-8660",
      email: "joe.simmons@swmc.com"
    }
  ];

  // Create SEO optimized HTML with proper links for each officer
  const createContactInfoHTML = (officer) => ({
    name: `<span>${officer.name}</span>`,
    nmls: `<span>NMLS ${officer.nmls}</span>`,
    title: `<span>${officer.title}</span>`,
    website: `<a href="https://${officer.angelaiUrl}" target="_blank" rel="noopener noreferrer" aria-label="Visit AngelAi profile" title="Visit AngelAi profile">${officer.angelaiUrl}</a>`,
    branchNmls: officer.branchNmls ? `<span>Branch NMLS ${officer.branchNmls}</span>` : null,
    phone: officer.phone ? `<a href="tel:+1${officer.phone.replace(/[^0-9]/g, '')}" className={styles.info_block_anchor}>D: ${officer.phone}</a>` : null,
    email: officer.email ? `<a href="mailto:${officer.email}" className={styles.info_block_anchor}>${officer.email}</a>` : null
  });

  return (
    <article>
      <Helmet>
        <title>Contact Us | Choose LowRate</title>
        
      </Helmet>

      <div className={styles.contact_us_div}>
        <Container fluid className={styles.contact_us_container}>
          <Row>
            <Col md={12} className={styles.contact_us_column}>
              <div className={styles.shadowcontainer}>
                <iframe
                  title="maps"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3051.7606790063987!2d-83.02098762388043!3d40.10304847149169!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8838f3343cb99c27%3A0xbab86371938da896!2s6797%20N%20High%20St%20%23131%2C%20Worthington%2C%20OH%2043085!5e0!3m2!1sen!2sus!4v1744734917702!5m2!1sen!2sus"
                  width="100%"
                  height="400"
                  frameBorder="0"
                  allowFullScreen=""
                  style={{ border: '0' }}
                  className={styles.responsiveIframe}
                ></iframe>
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={12} className="mt-5 mb-3">
              <h4 className={styles.contactustext}>Looking For Good Properties</h4>
              <h1 className={styles.contactustextbigger}>GET IN TOUCH</h1>
            </Col>
          </Row>

          <Row className={styles.contactInfoRow}>
            <Col md={4}>
              <div className={styles.contactInfoColumn}>
                <img src={imgCDNURL + "ContactusPage/homeicon.webp"} alt="Address icon" className={styles.icon_image} />
                <h5>ADDRESS:</h5>
                <a className={styles.info_block_anchor} href="https://maps.app.goo.gl/kheXnkadzfc6Tnmk8" target="_blank" rel="noopener noreferrer">
                  6797 N. High Street, Unit #131
                  <br />Worthington, OH 43085
                </a>
              </div>
            </Col>

            <Col md={4} className={styles.contactInfoColumn1}>
              <div className={styles.contactInfoColumn}>
                <img src={imgCDNURL + "ContactusPage/mailicon.webp"} alt="Email icon" className={styles.icon_image} />
                <h5>EMAIL ADDRESS:</h5>
                <a
                  className={styles.info_block_anchor}
                  href="mailto:kael.leather@swmc.com"
                >
                  kael.leather@swmc.com
                </a>
              </div>
            </Col>

            <Col md={4}>
              <div className={styles.contactInfoColumn}>
                <img src={imgCDNURL + "ContactusPage/phoneicon.webp"} alt="Phone icon" className={styles.icon_image} />
                <h5>PHONE NO:</h5>
                <a
                  className={styles.info_block_anchor}
                  href="tel:+18558923806"
                >
                  D: (855) 892-3806
                </a>
              </div>
            </Col>

            
          </Row>


          <Row>
            {loanOfficersData.map((officer, index) => {
              const contactInfoHTML = createContactInfoHTML(officer);
              return (
                <Col lg={6} key={index}>
                  {/* Loan Officer Info */}
                  <div className={`${styles.contactInfoColumn} ${styles.loContactusPageInfo}`}>
                    <div>
                      <Image
                        loading="eager"
                        alt={`${officer.name} Profile Photo`}
                        src={officer.imgUrl}
                        className={styles.lo_profile_image}
                        width={120}
                        height={120}
                      />
                    </div>
                    
                    <div className={styles.lo_info_box}>
                      <p className={styles.lo_name}>{parse(contactInfoHTML.name)}</p>
                      <p className={styles.lo_nmls}>{parse(contactInfoHTML.nmls)}</p>
                      <p className={styles.lo_title}>{parse(contactInfoHTML.title)}</p>
                      {contactInfoHTML.phone && <p className={styles.lo_phone}>{parse(contactInfoHTML.phone)}</p>}
                      {contactInfoHTML.email && <p className={styles.lo_email}>{parse(contactInfoHTML.email)}</p>}
                      <p className={styles.lo_website}>{parse(contactInfoHTML.website)}</p>
                      {contactInfoHTML.branchNmls && <p className={styles.lo_branch_nmls}>{parse(contactInfoHTML.branchNmls)}</p>}
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>
        </Container>
      </div>

      <div className={styles.contact_form_div}>
        <Container fluid className={styles.contact_form_container}>
          <Row>
            <Col md={12} className={`mt-3 mb-3 ${styles.contactformcolumn}`}>
              <LeadCaptureForm />
            </Col>
          </Row>
        </Container>
      </div>
    </article>
  );
};

export default ContactUs;